/*
 * Public API Surface of ngx-barcode6
 */

export * from './lib/ngx-barcode6';
